<div class="login-container">
	<mat-card class="mat-card-no-padding">
		<div class="row-center banner"></div>

		<div class="login-card-content">
			<ng-content></ng-content>
		</div>

		<div class="column-flex-end">
			<div class="row-flex-center">
				<mat-divider></mat-divider>
				<div class="tos-and-privacy-policy">
					<app-tos-and-privacy-policy></app-tos-and-privacy-policy>
				</div>
			</div>
		</div>
	</mat-card>
	<app-cookie-consent-bar />
</div>
